import { gql } from '@apollo/client';

export const GET_MY_FIELD_SESSION_QUERY = gql`
  query GetMyFieldSessionQuery($id: ID!, $filters: Filters) {
    getMyFieldSession(id: $id) {
      id
      clientId
      createdAt
      updatedAt
      startedAt
      endedAt
      siteId
      siteName
      name
      note
      activeDurationSeconds
      distanceMeters
      findCount
      track
      finds(filters: $filters) {
        id
        name
        evId
        createdAt
        updatedAt
        foundAt
        description
        latitude
        longitude
        type
        material
        era
        note
        siteId
        groupIds
        image
        images
        amcrId
        amcrData {
          images
        }
        visibility
        draft
      }
    }
  }
`;
